import $axios from '@/axios-instance.js'

export const fortnoxConnectionLogService = {
  getListData,
  cleanup
}

function getListData (payload) {
  return $axios.get(`${process.env.ROOT_API}/fortnox-connection-logs`, payload).then(response => {
    return response.data
  })
}

function cleanup (days) {
  return $axios.get(`${process.env.ROOT_API}/fortnox-connection-logs/cleanup`, days).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/fortnox-connection-logs.service.js